(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageUnusedListDialogController', NasracPackageUnusedListDialogController);

    NasracPackageUnusedListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracPackage'];

    function NasracPackageUnusedListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracPackage) {
        var vm = this;

        vm.nasracPackage = entity;
        vm.close = close;

        function close () {
            $uibModalInstance.dismiss('close');
        }

        vm.findPackageList = function  () {

                NasracPackage.query(vm.nasracPackage, onGetSuccess, onGetError);

        };

        function onGetSuccess (result) {
            vm.unusedPckList = findMissingNumbers(result);
        }

        function findMissingNumbers(result) {

            var a = [];
            // var missingList = [];
            var missingRangeList = [];
             for(var i=0;i<result.length;i++){
                 a.push(result[i].packageBsgHandle);
             }
            a = a.sort(function (e1, e2) {  return e1 - e2;  });

            var numberExists = true;
            var missingRange = "";
            var j = a[0];
            for (var i=0;i<a.length;i++)
            {
                if (j==a[i])
                {
                    if(!numberExists){
                        numberExists = !numberExists;
                        missingRange = missingRange +""+ (missingRange == j-1 ? "" : " - "+(j-1).toString() );
                        missingRangeList.push(missingRange);
                        missingRange = "";
                    }
                    numberExists = true;
                    j++;
                    continue;
                }
                else
                {
                    if(numberExists){
                        numberExists = !numberExists;
                        missingRange = j;
                    }
                    numberExists = false;
                    // missingList.push(j);
                    i--;
                    j++;
                }
            }
            return missingRangeList;

        }

        function onGetError (error) {
            //Error code here
        }
        vm.findPackageList();

    }
})();
